// const backEnd = process.env.NODE_ENV === 'production' ? 'https://backendlivejapan-ykqw6xki6a-an.a.run.app/' : 'http://localhost:5008/';
const backEnd = 'https://backendlivejapan-waouex2joa-an.a.run.app';
module.exports = backEnd;
